import * as React from "react";
import { SVGProps } from "react";

const CheckboxIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fill="#fff"
      d="M1 4a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4Z"
    />
    <path
      stroke={props.color}
      strokeWidth={2}
      d="M1 4a3 3 0 0 1 3-3h8a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H4a3 3 0 0 1-3-3V4Z"
    />
  </svg>
);
export default CheckboxIcon;
